import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { setupStore } from "./store/store";
import { Provider } from "react-redux";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import keycloak from "./keycloak/keycloak";
import NotificationAlert from "./components/ui/Notification/NotificationAlert";
import { APP_ID } from "./_app/consts";
import { WebAppProvider } from "@vkruglikov/react-telegram-web-app";
import { I18nextProvider } from "react-i18next";
import i18n from "./_i18n/config";

const store = setupStore();
const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <I18nextProvider i18n={i18n}>
    <BrowserRouter>
      <Provider store={store}>
        <WebAppProvider
          options={{
            smoothButtonsTransition: true,
          }}
        >
          <ReactKeycloakProvider
            authClient={keycloak}
            initOptions={{
              token: localStorage.getItem("token" + APP_ID),
              refreshToken: localStorage.getItem("refreshToken" + APP_ID),
              scope: "openid profile notification:state email notification:read",
              onLoad: "check-sso",
              pkceMethod: "S256",
              silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`,
            }}
          >
            <App />
            <NotificationAlert />
          </ReactKeycloakProvider>
        </WebAppProvider>
      </Provider>
    </BrowserRouter>
  </I18nextProvider>
);
